import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../styles/landing-page.css";
const Footer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleNavigation = (path) => {
    // Immediate scroll attempt
    window.scrollTo(0, 0);
    document.body.scrollTo(0, 0);
    document.documentElement.scrollTo(0, 0);

    navigate(path);

    // Delayed scroll to ensure it applies after render/transition
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTo(0, 0);
      document.documentElement.scrollTo(0, 0);
    }, 100);
  };

  return (
    <footer className="footer minimal-footer">
      <div className="footer-container">
        <div className="footer-logo-section">
          <img
            src="/icons/navbar/Sulhafa_Beta_Logo.png"
            alt="Sulhafa Logo"
            className="footer-logo"
          />
          <p className="footer-description">
            {t("landingFooter.description")}
          </p>
        </div>
        <div className="footer-columns">
          <div className="footer-column">
            <h3 className="footer-title">{t("landingFooter.exploreSulhafa.title")}</h3>
            <button
              className="footer-link"
              onClick={() => handleNavigation("/sulhafa-connect")}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                margin: 0,
                cursor: "pointer",
              }}
            >
              {t("landingFooter.exploreSulhafa.sulhafaConnect")}
            </button>
            <button
              className="footer-link"
              onClick={() => handleNavigation("/sulhafa-care")}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                margin: 0,
                cursor: "pointer",
              }}
            >
              {t("landingFooter.exploreSulhafa.sulhafaCare")}
            </button>
            {/* Shop link - Commented out for now - will be used later */}
            {/* 
            <button
              className="footer-link"
              onClick={() => handleNavigation("/sulhafa-shop")}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                margin: 0,
                cursor: "pointer",
              }}
            >
              Sulhafa Shop
            </button>
            */}

          </div>
          <div className="footer-column">
            <h3 className="footer-title" style={{ textAlign: "center" }}>{t("landingFooter.support.title")}</h3>
            <button
              className="footer-link"
              onClick={() => handleNavigation("/privacy")}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                margin: 0,
                cursor: "pointer",
              }}
            >
              {t("landingFooter.support.privacyPolicy")}
            </button>
            <button
              className="footer-link"
              onClick={() => handleNavigation("/terms")}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                margin: 0,
                cursor: "pointer",
              }}
            >
              {t("landingFooter.support.termsConditions")}
            </button>
            <button
              className="footer-link"
              onClick={() => handleNavigation("/contact")}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                margin: 0,
                cursor: "pointer",
              }}
            >
              {t("landingFooter.support.contactUs")}
            </button>
          </div>
          <div className="footer-column">
            <h3 className="footer-title">{t("landingFooter.stayConnected.title")}</h3>
            <p className="footer-subscribe-desc">
              {t("landingFooter.stayConnected.description")}
            </p>
            <form
              className="footer-subscribe-form"
              onSubmit={(e) => e.preventDefault()}
            >
              <input
                type="email"
                className="footer-input"
                placeholder={t("landingFooter.stayConnected.emailPlaceholder")}
                required
              />
              <button type="submit" className="footer-subscribe-btn">
                {t("landingFooter.stayConnected.subscribe")}
              </button>
            </form>
            <div className="footer-powered-by" style={{ marginTop: '24px', fontSize: '1rem', fontWeight: '500', color: '#303e4e' }}>
              {t("landingFooter.exploreSulhafa.PoweredbyRubix")}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
